import React, { useState } from "react";

const OtherDetails = () => {
  return (
    <>
      <div className="row pb-3">
        <div className="col-md-12">
          <div className="card px-3 py-2">
            <div className="row">
              <div className=" col-md-4 ">
                <label className="form-label">Purchase Order No</label>
                <input type="text" className="form-control form-control-sm" />
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">Purchase Order Date</label>
                <input type="date" className="form-control form-control-sm" />
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">AEO Code</label>
                <input type="text" className="form-control form-control-sm" />
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">Contract No.</label>
                <input type="text" className="form-control form-control-sm" />
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">Contract Date</label>
                <input type="date" className="form-control form-control-sm" />
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">AEO Country</label>
                <select className='form-control form-control-sm' id="prepaidCollect" >
                                <option value="Prepaid" selected >-</option>
                                <option value="Collection" >-</option>
                            </select>
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">Terms Of Payment</label>
                <select className='form-control form-control-sm' id="prepaidCollect" >
                                <option value="Prepaid" selected >-</option>
                                <option value="Collection" >-</option>
                            </select>
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">-</label>
                <input type="text" className="form-control form-control-sm" />
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">	AEO Role</label>
                <input type="date" className="form-control form-control-sm" />
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">Loc No.</label>
                <select className='form-control form-control-sm' id="prepaidCollect" >
                                <option value="Prepaid" selected >-</option>
                                <option value="Collection" >-</option>
                            </select>
              </div>
              <div className=" col-md-4 ">
                <label className="form-label"> Loc Date</label>
                <input type="date" className="form-control form-control-sm" />
              </div>
              <div className=" col-md-6 ">
                <label className="form-label">Nature Of Trans</label>
                <select className='form-control form-control-sm' id="prepaidCollect" >
                                <option value="Prepaid" selected >-</option>
                                <option value="Collection" >-</option>
                            </select>
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">-</label>
                <input type="text" className="form-control form-control-sm" />
              </div>
              <div className=" col-md-6 ">
                <label className="form-label">Valuation Method</label>
                <select className='form-control form-control-sm' id="prepaidCollect" >
                                <option value="Prepaid" selected >-</option>
                                <option value="Collection" >-</option>
                            </select>
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">-</label>
                <input type="text" className="form-control form-control-sm" />
              </div>
              <div className=" col-md-12 ">
                <label className="form-label">Sale Condition</label>
                <textarea type="date" className="form-control form-control-sm" />
              </div>
              <div className=" col-md-12 ">
                <label className="form-label">Any other relevant info
                which has a bearing on value</label>
                <textarea type="text" className="form-control form-control-sm" />
              </div>
              <div className=" col-md-12 ">
                <label className="form-label">ITC License Details</label>
                <textarea type="text" className="form-control form-control-sm" />
              </div>
              <div className=" col-md-4 ">
                <label className="form-label">IGM</label>
                <select className='form-control form-control-sm' id="prepaidCollect" >
                                <option value="Prepaid" selected >-</option>
                                <option value="Collection" >-</option>
                            </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OtherDetails
